(function () {
  'use strict';

  const BANNER_SELECTORS = [
    '#shopify-pc__banner',
    '#shopify-privacy-banner',
    '[data-shopify-privacy-banner]',
    '.shopify-pc__banner__dialog',
  ];

  let rafId = 0;
  let lastHeight = -1;
  let bannerActive = false;
  let bannerNode = null;
  let resizeObserver = null;

  function findBanner() {
    for (let i = 0; i < BANNER_SELECTORS.length; i += 1) {
      const node = document.querySelector(BANNER_SELECTORS[i]);
      if (!node) continue;

      const style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') continue;
      if (node.hasAttribute('hidden')) continue;
      if (node.offsetHeight < 1) continue;

      return node;
    }

    return null;
  }

  function applyState(height) {
    const root = document.documentElement;
    const body = document.body;
    if (!body) return;

    if (height <= 0) {
      if (!bannerActive && lastHeight <= 0) return;
      bannerActive = false;
      lastHeight = 0;
      root.style.removeProperty('--poke-cookie-banner-height');
      body.classList.remove('has-cookie-banner');
      return;
    }

    if (bannerActive && lastHeight === height) return;

    bannerActive = true;
    lastHeight = height;
    root.style.setProperty('--poke-cookie-banner-height', `${height}px`);
    body.classList.add('has-cookie-banner');
  }

  function detachBannerObserver() {
    if (resizeObserver && bannerNode) {
      resizeObserver.unobserve(bannerNode);
    }
    bannerNode = null;
  }

  function measureAndApply() {
    const banner = findBanner();

    if (!banner) {
      detachBannerObserver();
      applyState(0);
      return;
    }

    if (banner !== bannerNode) {
      detachBannerObserver();
      bannerNode = banner;
      if (resizeObserver) resizeObserver.observe(bannerNode);
    }

    applyState(Math.ceil(banner.getBoundingClientRect().height));
  }

  function scheduleMeasure() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      measureAndApply();
    });
  }

  function init() {
    if (!document.body) return;

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(scheduleMeasure);
    }

    measureAndApply();

    window.addEventListener('resize', scheduleMeasure, { passive: true });
    window.addEventListener('orientationchange', scheduleMeasure, { passive: true });

    const appearanceObserver = new MutationObserver(scheduleMeasure);
    appearanceObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
